import {CREATE_BUS_NOTIFICATION_TEMPLATE} from '@/api'
import {RETRIEVE_BUS_NOTIFICATION_TEMPLATE_LIST} from '@/api'
import {GET_BUS_NOTIFICATION_TEMPLATE_INFO} from '@/api'
import {EDIT_BUS_NOTIFICATION_TEMPLATE} from '@/api'
import {DELETE_BUS_NOTIFICATION_TEMPLATE} from '@/api'
import {DELETE_BUS_NOTIFICATION_CATEGORY} from '@/api'
import {CREATE_BUS_NOTIFICATION_CATEGORY} from '@/api'
import {RETRIEVE_BUS_NOTIFICATION_CATEGORY} from '@/api'
import {UPDATE_BUS_NOTIFICATION_CATEGORY} from '@/api'
import {RETRIEVE_BUS_NOTIFICATION_CATEGORY_INFO} from '@/api'

export default {
  retrieveBusNotificationTemplateList({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      // console.log(response);
      if (response.data.data.bus_notification_template_list.length) {
        commit('retrieveBusNotificationTemplateList', {busNotificationTemplateList: response.data.data.bus_notification_template_list})
      }

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }

    RETRIEVE_BUS_NOTIFICATION_TEMPLATE_LIST({}, successCallback, errorCallback)
  },

  createBusNotificationTemplate({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.bus_notification_template_info) {
        // commit('retrievePlaceList', {adminNotificationTemplateList: response.data.data.place_info})
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }
    };

    CREATE_BUS_NOTIFICATION_TEMPLATE({data: payload.data}, successCallback, errorCallback)
  },

  editBusNotificationTemplate({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.bus_notification_template_info) {
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }
    };

    EDIT_BUS_NOTIFICATION_TEMPLATE({data: payload}, successCallback, errorCallback)
  },

  getBusNotificationTemplateInfo({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.bus_notification_template_info) {
        commit('getBusNotificationTemplateInfo', {busNotificationTemplateInfo: response.data.data.bus_notification_template_info})
      }
      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    GET_BUS_NOTIFICATION_TEMPLATE_INFO({payload}, successCallback, errorCallback)
  },

  deleteBusNotificationTemplate({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      commit('deleteBusNotificationTemplate', {busNotificationTemplateInfo: payload})

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    DELETE_BUS_NOTIFICATION_TEMPLATE({payload}, successCallback, errorCallback)
  },

  createBusNotificationCategory({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.bus_notification_category_info) {
        // commit('retrievePlaceList', {adminNotificationTemplateList: response.data.data.place_info})
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }
    };

    CREATE_BUS_NOTIFICATION_CATEGORY({data: payload.data}, successCallback, errorCallback)
  },

  retrieveBusNotificationCategoryList({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      // console.log(response);
      if (response.data.data.bus_notification_category_list.length) {
        commit('retrieveBusNotificationCategoryList', {busNotificationCategoryList: response.data.data.bus_notification_category_list})
      }

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }

    RETRIEVE_BUS_NOTIFICATION_CATEGORY({}, successCallback, errorCallback)
  },

  getBusNotificationCategoryInfo({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.bus_notification_category_info) {
        commit('retrieveBusNotificationCategoryInfo', {busNotificationCategoryInfo: response.data.data.bus_notification_category_info})
      }

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }

    RETRIEVE_BUS_NOTIFICATION_CATEGORY_INFO({data: payload}, successCallback, errorCallback)
  },

  updateBusNotificationCategory({commit}, payload) {
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.bus_notification_category_info) {
        commit('retrieveBusNotificationCategoryInfo', {busNotificationCategoryInfo: response.data.data.bus_notification_category_info})
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }
    };

    UPDATE_BUS_NOTIFICATION_CATEGORY({data: payload}, successCallback, errorCallback)
  },

  deleteBusNotificationCategory({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      commit('deleteBusNotificationCategory', {busNotificationCategoryInfo: payload})

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    DELETE_BUS_NOTIFICATION_CATEGORY({payload}, successCallback, errorCallback)
  },
};
